<template>
  <div class="authWrapper new-login-wrapper">
    <div class="container">
      <div class="row whiteBG-wrap login-white-wrap">
        <div class="col-lg-7 col-md-7 no-padding">
          <div class="login-left-wrap">
            <router-link to="/login-password" class="ms-0 ps-0 login-highlight back-btn-pwd">Back</router-link>
          <div class="rep-icon-login">
            <img
              src="../../../assets/images/group-icon.svg"
              alt="image-fluid"
            />
          </div>
          <h4 class="login-title mb-2">Forgot Password</h4>
         
          <div class="auth-form pt-1 pb-3">
            <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
              <form @submit.stop.prevent="handleSubmit(checkUserInfo)">
                <input-form-text
                    :rules="{ required: true, email: true }"
                    :customMessages="`Please enter your email address.`"
                    :customEmailMessage="`Please enter a valid email address`"
                    labelFor="Email"
                    labelName="Email"
                    inputName="Email"
                    formGroupClass="form-group mb-1"
                    placeholder="Enter your email"
                    @emitChanges="resetErrorMsg"
                    :isErrorFlagSet="userEmailErrorFlag"
                    :vmodel.sync="userEmail"
                />
                <div class="valid-error" v-if="userEmailErrorFlag">
                  {{ errorMsg }}
                </div>
                <button
                :disabled="loginLoader"
                    class="submit-btn mt-3 next-btn"
                    type="submit"
                >
                  <b-spinner v-if="loginLoader" small></b-spinner>
                  Next
                </button>
              </form>
            </ValidationObserver>
          </div>
         <!-- <submit-issue /> -->
        </div>
        </div>
        <div class="col-lg-5 col-md-5 no-padding">
         <logincarsoule />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Logincarsoule from "./Logincarsoule";
import InputFormText from "../../../components/form/InputFormText.vue";
// import SubmitIssue from "./SubmitIssue";
export default {
  name: "ForgotPassword",

  data () {
    return {
      userEmail: '',
      optionType: '',
      loginLoader: false,
      errorMsg: '',
      userEmailErrorFlag: false,
      verificationIdentity: {}
    }
  },
  components: {
     Logincarsoule,
     InputFormText
    //  SubmitIssue
  },
  mounted() {
    this.userEmail = this.$store.getters.groupEmail
  },
  methods: {
    checkUserInfo() {
      let app = this;
      let url = process.env.VUE_APP_API_URL_V3 +`auth/reset-user-verify`;
      this.$store.commit("setAuthentication", false);
      this.$store.commit("setLoginOtpSource", 'forgot'); // Set the source for forgot password OTP

      app.loginLoader = true;
      app.optionType = 'email'
      axios
          .post(url, {
            email: app.userEmail,
          },)
          .then(function(response) {
            if (response.data.status == "success") {
              app.verificationIdentity = response.data.data
              app.$store.dispatch('groupInfoVerifyIdentity', app.verificationIdentity)
              app.$router.push('/verify-identity')
              app.loginLoader = false
            }
          })
          .catch(function(error) {
            if (error.response.data.status == "error") {
              app.loginLoader = false;
              app.userEmailErrorFlag = true
              app.errorMsg = error.response.data.message
            }
          });
    },
    resetErrorMsg () {
      let app = this
      app.userEmailErrorFlag = false
      app.errorMsg = ''
    }
  }
};
</script>
<style src="@/assets/css/authen.css"></style>
<style src="@/assets/css/newLogin.css"></style>

<style>
  #label-username,
  #label-password {
    font-size: 16px !important;
    color: #909090 !important;
    margin-bottom: 10px !important;
  }
  #username,
  #password {
    font-size: 14px !important;
    padding: 12px 15px !important;
  }
  .rep-icon-login {
    width: 80px;
  }
  /* .rep-icon-login img {
    width: 100px;
  } */

  .new-login-wrapper .invalid-feedback {
    color: #E73737;
    background-color: #FFE9E9;
    border-radius: 6px;
    padding: 0.5rem 0.8rem;
    margin-top: 0.1rem;
  }
  </style>
  
    